/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { rootGetApiV3 } from "../../funcs/rootGetApiV3.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$rootGetApiV3: ToolDefinition = {
  name: "root-get-api-v3",
  description: ``,
  tool: async (client, ctx) => {
    const [result, apiCall] = await rootGetApiV3(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
